export default "__VITE_ASSET__DeIKuFDr__"